module.exports = __webpack_public_path__ + "media/images/dmc/dmc_service-01-dec4b45067bdffb821818bfb1e6179e3.jpg";